module.exports = __webpack_public_path__ + "img/logo_SONGOROO_horizontalne-01.850c24e7.png";